import React, { FC } from "react";
import { Form, Button, Spin } from "antd";
import { useUserFunctionalities } from "../../../../utils/UserFunctionalities";
import DischargeDocumentUpload from "../IHX/IHXTabs/DischargeDocumentUpload";
import ResponseDischargeDocumentUpload from "../IHX/IHXTabs/ResponseDischargeDocumentUpload";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import EchsBasicDetails from "./EchsBasicDetails";
import EchsAdmissionDetails from "./EchsAdmissionDetails";
import EchsBillDetails from "./EchsBillDetails";
import { Link, useNavigate } from "react-router-dom";
import { BILL_AUDIT, ROUTES } from "../../../../utils/constants";
import 
EchsDiagnosticData from "./EchsDiagnosticData";

interface EchsDischargeFormProps {
  dischargeData: any;
  isEditable: boolean;
  caseDischargeId: number | null;
  portalSubmission: boolean;
  form: any;
  loading: boolean;
  documentTypes: any[];
  documentUrls: any[];
  documentRequestResponseDocuments: any;
  handleFileChange: any;
  handleOpen: any;
  isApproved: boolean;
  handleSaveData: any;
  preAuth: any;
  activeKey: any;
  isSubmitting?: boolean;
  isIntimating?: boolean;
  isSaving?: boolean;
  isApprovedInitiated?: boolean;
  handleSaveConfirmationModal: (state: string) => void;
  caseDischargeData: any;
  uploadFileList: any;
  setRemovedDiagnoses?: any;
}

const EchsDischargeForm: FC<EchsDischargeFormProps> = ({
  dischargeData,
  isEditable,
  caseDischargeId,
  portalSubmission,
  form,
  loading,
  documentTypes,
  documentUrls,
  documentRequestResponseDocuments,
  handleFileChange,
  handleOpen,
  isApproved,
  handleSaveData,
  preAuth,
  activeKey,
  isSubmitting,
  isIntimating,
  isSaving,
  isApprovedInitiated,
  handleSaveConfirmationModal,
  caseDischargeData,
  uploadFileList,
  setRemovedDiagnoses,
}) => {
  const { hasFunctionality } = useUserFunctionalities();
  const { auth, patients } = useSelector((state: RootState) => state);
  const navigate = useNavigate();
  const dateFormat = "DD-MM-YYYY HH:mm:ss";

  return (
    <div style={{ overflow: "auto" }}>
      {/* <EchsBasicDetails
        form={form}
        isEditable={isEditable}
        isApproved={isApproved}
        dateFormat={dateFormat}
      /> */}

      <EchsAdmissionDetails
        form={form}
        isEditable={isEditable}
        isApproved={isApproved}
        dateFormat={dateFormat}
      />

      {/* <EchsBillDetails
        form={form}
        isEditable={isEditable}
        isApproved={isApproved}
        dateFormat={dateFormat}
      /> */}

      <EchsDiagnosticData
        form={form}
        disabled={!isEditable}
        setRemovedDiagnoses={setRemovedDiagnoses}
        caseDischargeData={caseDischargeData}
      />

      {loading ? (
        <div
          style={{
            margin: "auto",
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Spin />
        </div>
      ) : (
        documentRequestResponseDocuments?.["requestedDocuments"]?.length >
          0 && (
          <DischargeDocumentUpload
            documentTypes={documentTypes}
            documentUrls={documentUrls}
            handleFileChange={handleFileChange}
            handleOpen={handleOpen}
            documentRequestResponseDocuments={documentRequestResponseDocuments}
            portalSubmission={portalSubmission}
            isApproved={isApproved}
            uploadFileList={uploadFileList}
            isIntimated={caseDischargeData?.intimated}
            isEchsScheme={true}
          />
        )
      )}

      {documentRequestResponseDocuments?.["responseDocuments"]?.length > 0 && (
        <ResponseDischargeDocumentUpload
          documentTypes={documentTypes}
          documentUrls={documentUrls}
          handleFileChange={handleFileChange}
          handleOpen={handleOpen}
          portalSubmission={portalSubmission}
          documentRequestResponseDocuments={documentRequestResponseDocuments}
          handleSaveData={handleSaveData}
          currentStage={preAuth?.stepperData?.currentVisitStage}
          activeKey={activeKey}
          uploadFileList={uploadFileList}
        />
      )}

      <div className="buttons" style={{ margin: "16px 0" }}>
        {
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "0.8rem",
            }}
          >
            {caseDischargeData?.submitted || caseDischargeData?.initiated ? (
              // || caseDischargeData?.approved
              <></>
            ) : !caseDischargeId ? (
              <div style={{ width: "16%" }}>
                <Button
                  type="primary"
                  style={{
                    backgroundColor: "rgb(0, 76, 143)",
                    color: "#fff",
                    boxShadow: "0px 2px 8px 0px #00000040",
                    width: "100%",
                  }}
                  // onClick={handleSubmit}
                  onClick={() => handleSaveConfirmationModal("save")}
                  loading={isSaving}
                >
                  SAVE
                </Button>
              </div>
            ) : (
              // !(
              //   auth?.role?.role == "FO_STAFF" && caseDischargeData?.intimated
              // ) &&
              <div style={{ width: "16%" }}>
                <Button
                  type="primary"
                  style={{
                    backgroundColor: "rgb(0, 76, 143)",
                    color: "#fff",
                    boxShadow: "0px 2px 8px 0px #00000040",
                    width: "100%",
                  }}
                  // onClick={handleSubmit}
                  onClick={() => handleSaveConfirmationModal("update")}
                  loading={isSaving}
                >
                  Update
                </Button>
              </div>
            )}
            {hasFunctionality("dischargeIntimation") ? (
              caseDischargeData?.intimated ||
              caseDischargeData?.submitted ||
              caseDischargeData?.initiated ||
              caseDischargeData?.approved ? (
                <></>
              ) : (
                <div style={{ width: "16%" }}>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "rgb(0, 76, 143)",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                    }}
                    // onClick={handleIntimate}
                    onClick={() => handleSaveConfirmationModal("intimate")}
                    loading={isIntimating}
                  >
                    Send To QC
                  </Button>
                </div>
              )
            ) : (
              <></>
            )}

            {patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
              "OP" &&
              (hasFunctionality("opdBillList") || hasFunctionality("ipdBillList")) && (
                <Link
                              to={`${BILL_AUDIT}/audit/${patients?.fetchBasicDetails?.visitInfoResponse?.billMappingId}`}
                              target="_blank"
                              style={{ width: "16%" }}
                            >
                <div>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "rgb(0, 76, 143)",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                      // opacity: !isApproved ? 1 : 0.5,
                      // pointerEvents: !isApproved ? "auto" : "none",
                    }}
                    // onClick={(e) => {
                    //   e.stopPropagation();
                    //   if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
                    //     navigate({
                    //       pathname: `${ROUTES.PATIENT_BILLING_LIST}/${patients?.fetchBasicDetails?.casesResponse?.id}/${patients?.fetchBasicDetails?.visitInfoResponse?.id}`,
                    //     });
                    //   }
                    // }}
                  >
                    Bill Audit
                  </Button>
                </div>
                </Link>
              )}
            {/* {(patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
              "IP" ||
              patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
                "EMERGENCY") &&
              hasFunctionality("ipdBillList") && (
                <div style={{ width: "16%" }}>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "rgb(0, 76, 143)",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                      // opacity: !isApproved ? 1 : 0.5,
                      // pointerEvents: !isApproved ? "auto" : "none",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
                        navigate({
                          pathname: `${ROUTES.PATIENT_BILLING_LIST}/${patients?.fetchBasicDetails?.casesResponse?.id}/${patients?.fetchBasicDetails?.visitInfoResponse?.id}`,
                        });
                      }
                    }}
                  >
                    Bill Audit
                  </Button>
                </div>
              )} */}

            {hasFunctionality("dischargeApprover") &&
              !caseDischargeData?.initiated &&
              !caseDischargeData?.approved &&
              !caseDischargeData?.submitted && (
                <div style={{ width: "16%" }}>
                  <Button
                    loading={isApprovedInitiated}
                    type="primary"
                    style={{
                      backgroundColor: "rgb(0, 76, 143)",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                      opacity: !isApproved ? 1 : 0.5,
                      pointerEvents: !isApproved ? "auto" : "none",
                    }}
                    // onClick={handleApprove}
                    onClick={() => handleSaveConfirmationModal("approve")}
                    disabled={isApproved}
                  >
                    QC Approve
                  </Button>
                </div>
              )}

            {hasFunctionality("dischargeSubmission") ? (
              caseDischargeData?.submitted || caseDischargeData?.initiated ? (
                <></>
              ) : (
                <div style={{ width: "16%" }}>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "rgb(0, 76, 143)",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                    }}
                    // onClick={handleSubmitOnPortal}
                    onClick={() => handleSaveConfirmationModal("submit")}
                    loading={isSubmitting}
                  >
                    {patients?.fetchBasicDetails?.casesResponse
                      ?.integratedWithPortal
                      ? "Initiate"
                      : "Submit Manually"}
                  </Button>
                </div>
              )
            ) : (
              <></>
            )}
          </div>
        }
      </div>
    </div>
  );
};

export default EchsDischargeForm;
